import { getAlert, getDataWithComp } from "./SamuiUtils";
import moment from "moment";

// ฟังก์ชันเรียก Electron Report (fallback กลับ browser ถ้าไม่สำเร็จ)
const callElectronReport = async (commandParams) => {
  try {
    if (window.electronAPI && window.electronAPI.runExe) {
      console.log("🖨️ Calling Electron Report:", commandParams);
      await window.electronAPI.runExe(commandParams);
      return true;
    }
    return false; // ไม่ได้รันใน Electron
  } catch (error) {
    console.error("❌ Electron Report Error:", error);
    return false; // fallback ไปใช้ browser แทน
  }
};

// เรียกรายงาน Crystal Report
const getReport = async (reportName, docNo, payload) => {
  try {
    if (!reportName) {
      getAlert("FAILED", "ไม่สามารถเปิดรายงานได้ กรุณาลองใหม่อีกครั้ง");
      return;
    }

    // ------------------ ตารางอ้างอิง ------------------
    let tableMap = {};
    if (
      process.env.REACT_APP_API_REPORT_URL ===
      "https://reporting.appsystemyou.com/api/reports/PosPB"
    ) {
      tableMap = {
        depos: {
          table: "DEPOS_H",
          filterColumn: "Doc_No",
          resultColumn: "Doc_Id",
        },
        pr: { table: "PR_H", filterColumn: "Doc_No", resultColumn: "Doc_Id" },
        po: { table: "PO_H", filterColumn: "Doc_No", resultColumn: "Doc_Id" },
        rec: { table: "REC_H", filterColumn: "Rec_No", resultColumn: "Rec_Id" },
        pay: { table: "PAY_H", filterColumn: "Pay_No", resultColumn: "Pay_Id" },
        so: { table: "SO_H", filterColumn: "Doc_No", resultColumn: "Doc_Id" },
        so_receipt: {
          table: "SO_H",
          filterColumn: "Doc_No",
          resultColumn: "Doc_Id",
        },
        bi1: { table: "BL_H", filterColumn: "Doc_No", resultColumn: "Doc_Id" },
        bi2: { table: "BL_H", filterColumn: "Doc_No", resultColumn: "Doc_Id" },
        inv_water_receipt: {
          table: "BL_H",
          filterColumn: "Doc_No",
          resultColumn: "Doc_Id",
        },
        inv1: {
          table: "INV_H",
          filterColumn: "Doc_No",
          resultColumn: "Doc_Id",
        },
        inv2: {
          table: "INV_H",
          filterColumn: "Doc_No",
          resultColumn: "Doc_Id",
        },
        TAX: {
          table: "API_1702_WTAX_D",
          filterColumn: "WTAX_Id",
          resultColumn: "WTAX_Id",
        },
        rc: { table: "SO_H", filterColumn: "Doc_No", resultColumn: "Doc_Id" },
        WHDOC: {
          table: "WHDoc_H",
          filterColumn: "WHDoc_No",
          resultColumn: "WHDoc_Id",
          typeColumn: "WHDoc_Type",
        },
        SUM_WHDOC_3: {
          table: "WHDoc_H",
          filterColumn: "WHDoc_No",
          resultColumn: "WHDoc_Id",
          typeColumn: "WHDoc_Type",
        },
        DAILY: { table: "SO_H" },
        DAILY_EXP_SL: { table: "SO_H" },
        DAILY_EXP_A4: { table: "SO_H" },
      };
    } else {
      tableMap = {
        depos: {
          table: "DEPOS_H",
          filterColumn: "Doc_No",
          resultColumn: "Doc_Id",
        },
        pr: { table: "PR_H", filterColumn: "Doc_No", resultColumn: "Doc_Id" },
        po: { table: "PO_H", filterColumn: "Doc_No", resultColumn: "Doc_Id" },
        rec: { table: "REC_H", filterColumn: "Rec_No", resultColumn: "Rec_Id" },
        pay: { table: "PAY_H", filterColumn: "Pay_No", resultColumn: "Pay_Id" },
        qt: { table: "QT_H", filterColumn: "Doc_No", resultColumn: "Doc_Id" },
        so: { table: "SO_H", filterColumn: "Doc_No", resultColumn: "Doc_Id" },
        so_receipt: {
          table: "SO_H",
          filterColumn: "Doc_No",
          resultColumn: "Doc_Id",
        },
        rc: { table: "SO_H", filterColumn: "Doc_No", resultColumn: "Doc_Id" },
        bi1: { table: "BL_H", filterColumn: "Doc_No", resultColumn: "Doc_Id" },
        bi2: { table: "BL_H", filterColumn: "Doc_No", resultColumn: "Doc_Id" },
        inv_water_receipt: {
          table: "BL_H",
          filterColumn: "Doc_No",
          resultColumn: "Doc_Id",
        },
        inv1: {
          table: "INV_H",
          filterColumn: "Doc_No",
          resultColumn: "Doc_Id",
        },
        inv2: {
          table: "INV_H",
          filterColumn: "Doc_No",
          resultColumn: "Doc_Id",
        },
        ib: {
          table: "WHDoc_Id",
          filterColumn: "WHDoc_No",
          resultColumn: "WHDoc_Id",
        },
        TAX: {
          table: "API_1702_WTAX_D",
          filterColumn: "WTAX_Id",
          resultColumn: "WTAX_Id",
        },
        bl_repeat: {
          table: "BL_H",
          filterColumn: "Doc_No",
          resultColumn: "Doc_Id",
        },
        WHDOC: {
          table: "WHDoc_H",
          filterColumn: "WHDoc_No",
          resultColumn: "WHDoc_Id",
          typeColumn: "WHDoc_Type",
        },
        SUM_WHDOC_3: {
          table: "WHDoc_H",
          filterColumn: "WHDoc_No",
          resultColumn: "WHDoc_Id",
          typeColumn: "WHDoc_Type",
        },
        SUM_WHDOC_2: {
          table: "WHDoc_H",
          filterColumn: "WHDoc_No",
          resultColumn: "WHDoc_Id",
          typeColumn: "WHDoc_Type",
        },
        SUM_WHDOC_1: {
          table: "WHDoc_H",
          filterColumn: "WHDoc_No",
          resultColumn: "WHDoc_Id",
          typeColumn: "WHDoc_Type",
        },
        DAILY: { table: "SO_H" },
        DAILY_EXP_SL: { table: "SO_H" },
        DAILY_EXP_A4: { table: "SO_H" },
      };
    }

    // ------------------ DAILY (ใช้ docNo เป็น object) ------------------
    if (reportName === "DAILY") {
      const { dateStart, dateEnd, whId } = docNo || {};
      if (!dateStart || !dateEnd || !whId) {
        getAlert("FAILED", "กรุณาระบุวันที่เริ่ม-สิ้นสุด และคลังสินค้าให้ครบ");
        return;
      }

      const env = process.env.REACT_APP_REPORT_ENV || "PRD";
      const userId = localStorage.getItem("userId") || "0";
      const commandParams = `${env} Auto DAILY ${whId} ${dateStart} ${dateEnd} ${userId}`;

      // ลองเรียกผ่าน Electron ก่อน
      const isElectron = await callElectronReport(commandParams);

      if (!isElectron) {
        // Fallback: เปิดผ่าน browser
        const whereClause = `AND  h.WH_Id = ${whId} AND ( h.Doc_Date >= '${dateStart}' AND  h.Doc_Date <= '${dateEnd}')`;
        const displayStart = moment(dateStart).add(543, "years").format("DD/MM/YYYY HH:mm:ss");
        const displayEnd = moment(dateEnd).add(543, "years").format("DD/MM/YYYY HH:mm:ss");
        const displaytimeprint = moment(new Date()).add(543, "years").format("DD/MM/YYYY HH:mm:ss");
        const displayEmp = localStorage.getItem("name") || "Unknown User";
        const pCondition = `วันที่ :  ${displayStart}\nถึง    : ${displayEnd}\nPrint : ${displaytimeprint}\nEmp : ${displayEmp} สถานที่ : ${localStorage.getItem("WHName") || "Unknown"}`;

        const link = document.createElement("a");
        link.href = `${process.env.REACT_APP_API_REPORT_URL}/DAILY?P_DOC_ID=${encodeURIComponent(whereClause)}&P_CONDITION=${encodeURIComponent(pCondition)}`;
        link.target = "_blank";
        link.rel = "noopener noreferrer";
        link.click();
      }
      return;
    }

    if (reportName === "DAILY_EXP_SL") {
      const { dateStart, dateEnd, whId } = docNo || {};
      if (!dateStart || !dateEnd || !whId) {
        getAlert("FAILED", "กรุณาระบุวันที่เริ่ม-สิ้นสุด และคลังสินค้าให้ครบ");
        return;
      }

      const env = process.env.REACT_APP_REPORT_ENV || "PRD";
      const userId = localStorage.getItem("userId") || "0";
      const commandParams = `${env} Auto DAILY_EXP_SL ${whId} ${dateStart} ${dateEnd} ${userId}`;

      const isElectron = await callElectronReport(commandParams);

      if (!isElectron) {
        // Fallback: browser
        const whereClause = `AND h.WH_Id = ${whId} AND h.Doc_Date  BETWEEN '${dateStart}' AND  '${dateEnd}' AND Doc_Status != 13`;
        const displayStart = moment(dateStart).add(543, "years").format("DD/MM/YYYY HH:mm:ss");
        const displayEnd = moment(dateEnd).add(543, "years").format("DD/MM/YYYY HH:mm:ss");
        const displaytimeprint = moment().add(543, "years").format("DD/MM/YYYY HH:mm:ss");
        const displayEmp = localStorage.getItem("name") || "Unknown User";
        const whName = localStorage.getItem("WHName") || "Unknown";

        const pCondition =
          `วันที่ :  ${displayStart}\r\n` +
          `ถึง    : ${displayEnd}\r\n` +
          `Print : ${displaytimeprint}\r\n` +
          `Emp : ${displayEmp}` + " " + " " + `สถานที่ : ${whName}`;

        const url = new URL(`${process.env.REACT_APP_API_REPORT_URL}/DAILY_EXP_SL`);
        url.search = new URLSearchParams({
          P_DOC_ID: whereClause,
          P_CONDITION: pCondition,
        }).toString();

        const link = document.createElement("a");
        link.href = url.toString();
        link.target = "_blank";
        link.rel = "noopener noreferrer";
        link.click();
      }
      return;
    }

    if (reportName === "DAILY_EXP_A4") {
      const { dateStart, dateEnd, whId } = docNo || {};
      if (!dateStart || !dateEnd || !whId) {
        getAlert("FAILED", "กรุณาระบุวันที่เริ่ม-สิ้นสุด และคลังสินค้าให้ครบ");
        return;
      }

      const env = process.env.REACT_APP_REPORT_ENV || "PRD";
      const userId = localStorage.getItem("userId") || "0";
      const commandParams = `${env} Auto DAILY_EXP_A4 ${whId} ${dateStart} ${dateEnd} ${userId}`;

      const isElectron = await callElectronReport(commandParams);

      if (!isElectron) {
        // Fallback: browser
        const whereClause = `AND h.WH_Id = ${whId} AND h.Doc_Date  BETWEEN '${dateStart}' AND  '${dateEnd}' AND Doc_Status != 13`;
        const displayStart = moment(dateStart).add(543, "years").format("DD/MM/YYYY ");
        const displayEnd = moment(dateEnd).add(543, "years").format("DD/MM/YYYY ");
        const displaytimeprint = moment().add(543, "years").format("DD/MM/YYYY HH:mm:ss");
        const displayEmp = localStorage.getItem("name") || "Unknown User";
        const whName = localStorage.getItem("WHName") || "Unknown";

        const pCondition = `วันที่ :  ${displayStart}\r\n` + `ถึง   : ${displayEnd}\r\n`;
        const pCondition2 =
          `วันที่ออกรายงาน : ${displaytimeprint}\r\n` +
          `ผู้ออกรายงาน : ${displayEmp}` + " " + " " + `สถานที่ : ${whName}`;

        const url = new URL(`${process.env.REACT_APP_API_REPORT_URL}/DAILY_EXP_A4`);
        url.search = new URLSearchParams({
          P_DOC_ID: String(whereClause),
          P_CONDITION: pCondition,
          P_CONDITION2: pCondition2,
        }).toString();

        const link = document.createElement("a");
        link.href = url.toString();
        link.target = "_blank";
        link.rel = "noopener noreferrer";
        link.click();
      }
      return;
    }

    // ------------------ SUM_WHDOC_3 (พิเศษ) ------------------
    if (reportName === "SUM_WHDOC_3") {
      const pl =
        payload && typeof payload === "object"
          ? payload
          : docNo && typeof docNo === "object"
          ? docNo
          : null;

      const pDocId = pl?.WHDoc_Id?.toString().trim();
      const pCondition = pl?.Date || "";
      const pCondition2 = pl?.selectedWarehouseFrom || "ทั้งหมด";
      const pCondition3 = Array.isArray(pl?.whDocRemarks)
        ? pl.whDocRemarks.length > 1
          ? "ทั้งหมด"
          : pl.whDocRemarks[0] ?? "-"
        : pl?.whDocRemarks ?? "-";

      const pCondition4 = pl?.acc || "system";

      if (!pDocId) {
        getAlert("FAILED", "กรุณาเลือกรายการเอกสารสำหรับรายงานสรุป (SUM_WHDOC_3)");
        return;
      }

      const link = document.createElement("a");
      link.href =
        `${process.env.REACT_APP_API_REPORT_URL}/SUM_WHDOC_3` +
        `?P_DOC_ID=${encodeURIComponent(pDocId)}` +
        `&P_CONDITION=${encodeURIComponent(pCondition)}` +
        `&P_CONDITION2=${encodeURIComponent(pCondition2)}` +
        `&P_CONDITION3=${encodeURIComponent(pCondition3)}` +
        `&P_CONDITION4=${encodeURIComponent(pCondition4)}`;
      link.target = "_blank";
      link.rel = "noopener noreferrer";
      link.click();
      return;
    }
    if (reportName === "SUM_WHDOC_2") {
      const pl =
        payload && typeof payload === "object"
          ? payload
          : docNo && typeof docNo === "object"
          ? docNo
          : null;

      console.debug("getReport SUM_WHDOC_2 pl", pl);

      const pDocId = pl?.WHDoc_Id?.toString().trim();
      const pCondition = pl?.Date || "";
      const pCondition2 = pl?.selectedWarehouseFrom || "ทั้งหมด";
      const pCondition3 = "";
      const pCondition4 = pl?.acc || "system";

      if (!pDocId) {
        getAlert("FAILED", "กรุณาเลือกรายการเอกสารสำหรับรายงานสรุป (SUM_WHDOC_2)");
        return;
      }

      const link = document.createElement("a");
      link.href =
        `${process.env.REACT_APP_API_REPORT_URL}/SUM_WHDOC_2` +
        `?P_DOC_ID=${encodeURIComponent(pDocId)}` +
        `&P_CONDITION=${encodeURIComponent(pCondition)}` +
        `&P_CONDITION2=${encodeURIComponent(pCondition2)}` +
        `&P_CONDITION3=${encodeURIComponent(pCondition3)}` +
        `&P_CONDITION4=${encodeURIComponent(pCondition4)}`;
      link.target = "_blank";
      link.rel = "noopener noreferrer";
      link.click();
      return;
    }
    if (reportName === "SUM_WHDOC_1") {
      const pl =
        payload && typeof payload === "object"
          ? payload
          : docNo && typeof docNo === "object"
          ? docNo
          : null;

      console.debug("getReport SUM_WHDOC_1 pl", pl);

      const pDocId = pl?.WHDoc_Id?.toString().trim();
      const pCondition = pl?.Date || "";
      const pCondition2 = pl?.selectedWarehouseFrom || "ทั้งหมด";
      const pCondition3 = Array.isArray(pl?.whDocRemarks)
        ? pl.whDocRemarks.length > 1
          ? "ทั้งหมด"
          : pl.whDocRemarks[0] ?? "-"
        : pl?.whDocRemarks ?? "-";

      const pCondition4 = pl?.acc || "system";

      if (!pDocId) {
        getAlert("FAILED", "กรุณาเลือกรายการเอกสารสำหรับรายงานสรุป (SUM_WHDOC_1)");
        return;
      }

      const link = document.createElement("a");
      link.href =
        `${process.env.REACT_APP_API_REPORT_URL}/SUM_WHDOC_1` +
        `?P_DOC_ID=${encodeURIComponent(pDocId)}` +
        `&P_CONDITION=${encodeURIComponent(pCondition)}` +
        `&P_CONDITION2=${encodeURIComponent(pCondition2)}` +
        `&P_CONDITION3=${encodeURIComponent(pCondition3)}` +
        `&P_CONDITION4=${encodeURIComponent(pCondition4)}`;
      link.target = "_blank";
      link.rel = "noopener noreferrer";
      link.click();
      return;
    }
    if (!docNo) {
      getAlert("FAILED", "กรุณาระบุเลขเอกสาร");
      return;
    }

    const reportConfig = tableMap[reportName];
    if (!reportConfig) {
      getAlert("FAILED", "ไม่พบรายงานที่ต้องการ");
      return;
    }

    let pDocId = null;

    if (reportName === "tax" || reportName === "TAX") {
      pDocId = docNo;
    } else if (reportName === "WHDOC") {
      const result = await getDataWithComp(
        "WHDoc_H",
        `AND WHDoc_No = '${docNo}'`
      );
      pDocId = result?.[0]?.WHDoc_Id;
      if (!pDocId) {
        getAlert("FAILED", "ไม่พบข้อมูลที่ต้องการ");
        return;
      }
      const pCondition = result?.[0]?.WHDoc_Type || "1";

      const link = document.createElement("a");
      link.href = `${
        process.env.REACT_APP_API_REPORT_URL
      }/WHDOC?P_DOC_ID=${encodeURIComponent(
        pDocId
      )}&P_CONDITION=${encodeURIComponent(pCondition)}`;
      link.target = "_blank";
      link.rel = "noopener noreferrer";
      link.click();
      return;
    } else {
      const { table, filterColumn, resultColumn } = reportConfig;
      const found = await getDataWithComp(
        table,
        `AND ${filterColumn} = '${docNo}'`
      );
      pDocId = found?.[0]?.[resultColumn];
    }

    // เช็คพบทุกรายงานทั่วไป
    if (!pDocId) {
      getAlert("FAILED", "ไม่พบข้อมูลที่ต้องการ");
      return;
    }

    const link = document.createElement("a");
    if (reportName === "bi1" || reportName === "bi2") {
      link.href =
        `${process.env.REACT_APP_API_REPORT_URL}/bi` +
        `?P_DOC_ID=${encodeURIComponent(pDocId)}` +
        `&P_CONDITION=${encodeURIComponent(
          reportName === "bi1" ? "ต้นฉบับ" : "สำเนา"
        )}`;
    } else if (reportName === "inv1" || reportName === "inv2") {
      link.href =
        `${process.env.REACT_APP_API_REPORT_URL}/inv_water` +
        `?P_DOC_ID=${encodeURIComponent(pDocId)}` +
        `&P_CONDITION=${encodeURIComponent(reportName === "inv1" ? "1" : "2")}`;
    } else {
      link.href =
        `${process.env.REACT_APP_API_REPORT_URL}/${reportName}` +
        `?P_DOC_ID=${encodeURIComponent(pDocId)}` +
        `&P_CONDITION=${encodeURIComponent("ต้นฉบับ")}`;
    }

    link.target = "_blank";
    link.rel = "noopener noreferrer";
    link.click();
  } catch (error) {
    console.error("Error fetching data:", error);
    getAlert("FAILED", error?.message || String(error));
  }
};

export { getReport };
